export default __webpack_public_path__ + "static/media/nachos.d87cb27e.jpg";